module.exports = __webpack_public_path__ + "static/media/stories_land_icon.2ec0f5a7.svg";